module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "desc"
  }, [_vm._v("\n    视频中提到(" + _vm._s(_vm.noticeList.length) + ")\n  ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowLoading),
      expression: "isShowLoading"
    }],
    staticClass: "loading"
  }), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('ul', _vm._l((_vm.noticeList), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      class: item.typeClass,
      attrs: {
        "href": item.href
      }
    }, [_c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "pic"
    }, [_c('div', {
      staticClass: "lazy-img",
      attrs: {
        "data-imgurl": _vm.fixImgUrl(item.avatar),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "name title"
    }, [_c('span', {
      staticClass: "shop_name"
    }, [_vm._v("\n                    " + _vm._s(item.title) + "\n                  ")])]), _vm._v(" "), (item.price || (item.objectType != 2 && item.objectType != 6 && item.objectType != 7 && item.objectType != 8 && item.objectType != 9 && item.objectType != 10 && item.objectType != 11 && item.objectType != 12)) ? _c('div', {
      staticClass: "comment"
    }, [_c('span', {
      staticClass: "star",
      class: item.starClass
    }), _vm._v(" "), _c('span', {
      staticClass: "price"
    }, [_vm._v(_vm._s(item.price))])]) : _vm._e(), _vm._v(" "), (item.objectType === 8 || item.objectType === 9 || item.objectType === 10 || item.objectType === 11) ? _c('div', {
      staticClass: "comment"
    }, [_c('span', {
      staticClass: "price"
    }, [_vm._v(_vm._s(item.labelFirst))])]) : _vm._e(), _vm._v(" "), (item.objectType == 12) ? [_c('div', {
      staticClass: "intro col"
    }, [_c('p', {
      staticClass: "hasSec"
    }, [_vm._v(_vm._s(item.labelFirst))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.labelSecond))])])] : [_c('div', {
      staticClass: "intro",
      class: item.objectType == 2 || item.objectType == 6 || item.objectType == 7 ? 'col' : ''
    }, [(item.objectType != 8 && item.objectType != 9 && item.objectType != 10 && item.objectType != 11) ? _c('span', {
      class: item.labelSecond ? 'hasSec' : ''
    }, [_vm._v(_vm._s(item.labelFirst))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "type"
    }, [_vm._v(_vm._s(item.labelSecond))])])]], 2)])])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-575cec55!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/noticelist.vue
// module id = 615
// module chunks = 10